import React, { useState, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  FaHome, 
  FaUsers, 
  FaFileAlt, 
  FaUpload, 
  FaSignOutAlt,
  FaUserCircle,
  FaBars,
  FaTimes,
  FaCalculator,
  FaChevronDown,
  FaChevronRight,
  //FaBook,
  //FaPen,
  //FaList,
  //FaBalanceScale,
  //FaLock,
  // 
  FaChartLine
} from 'react-icons/fa';
import NotificationBell from '../common/NotificationBell';

const Header = () => {
  const { currentUser, logout, hasPermission } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showComptaSubmenu, setShowComptaSubmenu] = useState(false);
  const dropdownRef = useRef(null);
  const comptaSubmenuRef = useRef(null);
  
  // Fonction de déconnexion améliorée
  const handleLogout = async () => {
    try {
      setShowDropdown(false);
      setIsOpen(false);
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
  };

  // Gestion du dropdown utilisateur
  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };

  // Gestion du sous-menu comptabilité
  /*
  const handleComptaSubmenu = () => {
    setShowComptaSubmenu(!showComptaSubmenu);
  };
  */

  // Fermeture des dropdowns au clic extérieur
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
    if (comptaSubmenuRef.current && !comptaSubmenuRef.current.contains(event.target)) {
      setShowComptaSubmenu(false);
    }
  };

  // Effet pour écouter les clics extérieurs
  React.useEffect(() => {
    if (showDropdown || showComptaSubmenu) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showDropdown, showComptaSubmenu]);

  // Vérifier si un lien est actif
  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  // Vérifier si le module comptabilité est actif
  const isComptaActive = () => {
    return location.pathname.startsWith('/comptabilite') || location.pathname === '/compta';
  };

  // Configuration des sous-menus comptabilité
  const comptabiliteSubmenu = [
    {
      name: 'Tableau de bord',
      href: '/comptabilite',
      icon: FaChartLine,
      description: 'Vue d\'ensemble comptable'
    }
    
    /*
    ,
    {
      name: 'Plan comptable',
      href: '/comptabilite?module=plan-comptable',
      icon: FaBook,
      description: 'Gestion du plan OHADA'
    },

    {
      name: 'Saisie d\'écritures',
      href: '/comptabilite?module=saisie',
      icon: FaPen,
      permission: 'canCreateEntries',
      description: 'Créer des écritures comptables'
    },
    {
      name: 'Journaux',
      href: '/comptabilite?module=journaux',
      icon: FaList,
      description: 'Consulter les journaux'
    },
    {
      name: 'Balance',
      href: '/comptabilite?module=balance',
      icon: FaBalanceScale,
      description: 'Balance générale'
    },
    {
      name: 'États financiers',
      href: '/comptabilite?module=etats-financiers',
      icon: FaChartLine,
      description: 'Bilan, compte de résultat'
    },
    {
      name: 'Clôtures',
      href: '/comptabilite?module=cloture',
      icon: FaLock,
      permission: 'canClosePeriods',
      description: 'Clôture mensuelle et annuelle'
    }
      */
  ];

  // Filtrer les sous-menus selon les permissions
  const comptaMenusAutorises = comptabiliteSubmenu.filter(item => 
    !item.permission || hasPermission(item.permission) || currentUser?.role === 'admin'
  );

  if (!currentUser) {
    return null;
  }
  
  // Ne pas afficher le header sur la page photothèque (Plein écran)
  if (location.pathname === '/phototheque') {
    return null;
  }
  
  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo et navigation desktop */}
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <span className="text-2xl font-bold text-primary-600">
                Etats en ligne
              </span>
            </div>
            
            {/* Navigation desktop */}
            <nav className="ml-6 hidden md:flex space-x-8">
              {hasPermission('canViewDashboard') && (
                <Link
                  to="/"
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium 
                  ${isActive('/') && !isComptaActive()
                    ? 'border-primary-500 text-gray-900' 
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
                >
                  <FaHome className="mr-2" />
                  Tableau de bord
                </Link>
              )}
              
              <Link
                to="/contracts"
                className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium 
                ${isActive('/contracts') 
                  ? 'border-primary-500 text-gray-900' 
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
              >
                <FaFileAlt className="mr-2" />
                Contrats
              </Link>
              

              {/* Enleve de la barre de menu principale----------------------------------------------
                {hasPermission('canImport') && (
                  <Link
                    to="/imports"
                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium 
                    ${isActive('/imports') 
                      ? 'border-primary-500 text-gray-900' 
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
                  >
                    <FaUpload className="mr-2" />
                    I. Locales
                  </Link>
                )}
              */}



              <Link
                to="/comptabilite"
                className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium 
                ${isActive('/comptabilite') || isActive('/compta')  
                  ? 'border-primary-500 text-gray-900' 
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
              >
                <FaFileAlt className="mr-2" />
                Comptabilité
              </Link>


                  
              

              

              {hasPermission('canManageUsers') && (
                <Link
                  to="/users"
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium 
                  ${isActive('/users') 
                    ? 'border-primary-500 text-gray-900' 
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
                >
                  <FaUsers className="mr-2" />
                  Utilisateurs
                </Link>
              )}
            </nav>
          </div>
          
          {/* Menu utilisateur desktop */}
          <div className="hidden md:flex items-center space-x-3">
            <NotificationBell />
            
            {/* Lien importations planifiées pour admins */}
            {(currentUser.role === 'admin' || currentUser.role === 'admin_assistant') && (
              <Link 
                to="/scheduled-imports" 
                className={`text-sm px-3 py-2 rounded-md transition-colors ${
                  isActive('/scheduled-imports')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                I. Planifiées
              </Link>
            )}

            {/* Dropdown utilisateur */}
            <div className="relative" ref={dropdownRef}>
              <button 
                className="flex items-center space-x-2 text-gray-700 py-2 px-3 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500"
                onClick={handleDropdownToggle}
                type="button"
              >
                <FaUserCircle className="text-primary-600" />
                <span>{currentUser.username} ({currentUser.role === 'admin' 
                  ? 'Admin' 
                  : currentUser.role === 'admin_assistant' 
                    ? 'Assistant' 
                    : 'Visiteur'})</span>
                <FaChevronDown className="h-3 w-3" />
              </button>
              
              {showDropdown && (
                <div className="absolute right-0 z-10 mt-2 w-48 bg-white shadow-lg rounded-md border border-gray-200">
                  <div className="py-1">
                    <Link
                      to="/profile"
                      className="flex items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => setShowDropdown(false)}
                    >
                      <FaUserCircle />
                      <span>Mon profil</span>
                    </Link>
                    <button
                      onClick={handleLogout}
                      type="button"
                      className="flex w-full items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                    >
                      <FaSignOutAlt />
                      <span>Déconnexion</span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          
          {/* Bouton hamburger pour le menu mobile */}
          <div className="md:hidden flex items-center">
            <NotificationBell />
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="ml-2 text-gray-700 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500"
              type="button"
            >
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </div>
      
      {/* Menu mobile */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-lg py-2 border-t border-gray-200">
          <div className="flex flex-col space-y-2 px-4">
            {hasPermission('canViewDashboard') && (
              <Link
                to="/"
                className={`flex items-center space-x-2 py-2 px-4 rounded-md ${
                  isActive('/') && !isComptaActive()
                    ? 'bg-primary-100 text-primary-700' 
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
                onClick={() => setIsOpen(false)}
              >
                <FaHome />
                <span>Tableau de bord</span>
              </Link>
            )}
            
            <Link
              to="/contracts"
              className={`flex items-center space-x-2 py-2 px-4 rounded-md ${
                isActive('/contracts') 
                  ? 'bg-primary-100 text-primary-700' 
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
              onClick={() => setIsOpen(false)}
            >
              <FaFileAlt />
              <span>Contrats</span>
            </Link>
            
            {hasPermission('canImport') && (
              <Link
                to="/imports"
                className={`flex items-center space-x-2 py-2 px-4 rounded-md ${
                  isActive('/imports') 
                    ? 'bg-primary-100 text-primary-700' 
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
                onClick={() => setIsOpen(false)}
              >
                <FaUpload />
                <span>Importations</span>
              </Link>
            )}

            {/* NOUVEAU : Section Comptabilité mobile */}
            <div className="border-t border-gray-200 my-2"></div>
            <div className="px-2">
              <button
                onClick={() => setShowComptaSubmenu(!showComptaSubmenu)}
                className={`flex items-center justify-between w-full py-2 px-4 rounded-md ${
                  isComptaActive()
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-gray-700 hover:bg-gray-100'
                } focus:outline-none`}
              >
                <div className="flex items-center space-x-2">
                  <FaCalculator />
                  <span>Comptabilité</span>
                </div>
                {showComptaSubmenu ? <FaChevronDown /> : <FaChevronRight />}
              </button>

              {/* Sous-menu comptabilité mobile */}
              {showComptaSubmenu && (
                <div className="mt-2 ml-4 space-y-1">
                  {comptaMenusAutorises.map((item) => {
                    const IconComponent = item.icon;
                    return (
                      <Link
                        key={item.name}
                        to={item.href}
                        className="flex items-center space-x-2 py-2 px-3 text-sm text-gray-600 hover:bg-gray-100 rounded-md"
                        onClick={() => {
                          setIsOpen(false);
                          setShowComptaSubmenu(false);
                        }}
                      >
                        <IconComponent className="text-primary-500" />
                        <span>{item.name}</span>
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
            






            {hasPermission('canManageUsers') && (
              <Link
                to="/users"
                className={`flex items-center space-x-2 py-2 px-4 rounded-md ${
                  isActive('/users') 
                    ? 'bg-primary-100 text-primary-700' 
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
                onClick={() => setIsOpen(false)}
              >
                <FaUsers />
                <span>Utilisateurs</span>
              </Link>
            )}

            {/* Importations planifiées mobile */}
            {(currentUser.role === 'admin' || currentUser.role === 'admin_assistant') && (
              <Link
                to="/scheduled-imports"
                className={`flex items-center space-x-2 py-2 px-4 rounded-md ${
                  isActive('/scheduled-imports') 
                    ? 'bg-primary-100 text-primary-700' 
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
                onClick={() => setIsOpen(false)}
              >
                <FaUpload />
                <span>Importations Planifiées</span>
              </Link>
            )}
            
            <div className="border-t border-gray-200 my-2"></div>
            
            <Link
              to="/profile"
              className="flex items-center space-x-2 py-2 px-4 text-gray-700 hover:bg-gray-100 rounded-md"
              onClick={() => setIsOpen(false)}
            >
              <FaUserCircle />
              <span>Mon profil</span>
            </Link>
            
            <button
              onClick={handleLogout}
              type="button"
              className="flex items-center space-x-2 py-2 px-4 text-gray-700 hover:bg-gray-100 rounded-md w-full text-left focus:outline-none focus:bg-gray-100"
            >
              <FaSignOutAlt />
              <span>Déconnexion</span>
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;